$(document).bind('click',function (e) {
  if (!((e.target.className.indexOf('add-account-btn0') > -1) || $(e.target).parents('.add-account-btn0').length > 0)) {
    $('.utm-account-wapper0').slideUp(300);
  }
  if (!((e.target.className.indexOf('add-account-btn1') > -1) || $(e.target).parents('.add-account-btn1').length > 0)) {
    $('.utm-account-wapper1').slideUp(300);
  }
  if (!((e.target.className.indexOf('add-account-btn2') > -1) || $(e.target).parents('.add-account-btn2').length > 0)) {
    $('.utm-account-wapper2').slideUp(300);
  }
})
let _this
export default {
  name: 'forwardEmail',

  data() {
    return {
      id:'',
      sendEmailModal:false,
      isAutoSendEmail:false,
      allRoleList:[], /*所有角色*/
      allAccountGroupList:[],/*所有账号组*/
      allAccountList: [],/*所有账号*/
      selectedRoles:[],
      selectedAccountGroups:[],
      selectedAccounts:[],
      accountGroupName:'',/*账号组搜索词*/
      accountName: '',/*管理员搜索词*/
      roleName:'',/*角色搜索词*/
      editEmailModal: false,/*编辑邮箱模态框*/
      cursorPosition:0,/*光标位置*/
      emailSubject:'',
      emailContent:'',
      emailFlag: false,
      emailText: '',/*邮箱内容填写*/
      emailTitle:'',
      emailTitleFlag: false,
      reciverData:{
        enabledPaging:false,
        sortName:'name',
        sortType:0,
        name:'',
      },
      receivers:[
        {
          receiverGroupIds: [],
          receiverIds: [],
          receiverRoleIds :[],
          receiverFlag: false,
        }
      ]
    }
  },
  mounted() {
    _this = this;
    eventBus.$on('forwardEmail', (id) => {
      _this.id = id;
      _this.init();
      _this.getSelectDate();
    })
  },
  beforeDestroy() {
    eventBus.$off('forwardEmail');
  },
  methods: {
    init:function(){
      _this.reciverData = {
        enabledPaging:false,
          sortName:'name',
          sortType:0,
          name:'',
      };
      _this.receivers = [
        {
          receiverGroupIds: [],
          receiverIds: [],
          receiverRoleIds :[],
          receiverFlag: false,
        }
      ];
      _this.emailSubject = '';
      _this.emailContent = '';
      _this.emailTitleFlag = false;
      _this.emailFlag = false;
      _this.sendEmailModal = true;
    },
    getSelectDate:function(){
      let data = {
        enabledPaging:false,
        sortName:'name',
        sortType:0,
      }
      this.$ajax.post('Accounts/Pagination',data,{headers: {'noLoading': true},baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if(res.data.success){
          _this.selectedAccounts = res.data.data.items;
        }else{
          _this.messageNotice('error', res.data.message);
        }
      });
      this.$ajax.post('AccountGroups/Paginate', data,{headers: {'noLoading': true} ,baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if (res.data.success) {
          _this.selectedAccountGroups = res.data.data.items;
        } else {
          _this.messageNotice('error', res.data.message);
        }
      });
      this.$ajax.post('Roles/Pagination', data,{headers: {'noLoading': true} ,baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if (res.data.success) {
          _this.selectedRoles = res.data.data.items;
        } else {
          _this.messageNotice('error', res.data.message);
        }
      });
    },
    // 查看所有账号
    openAccount: function (e,val) {
      _this.reciverType = val;
      if(val === 0 ){
        _this.getAllAccount();
        $(e.target).parents('.account-box').find('.utm-account-wapper0').slideDown(300);
      }else if (val === 1) {
        _this.queryAccountGroup();
        $(e.target).parents('.account-box').find('.utm-account-wapper1').slideDown(300);
      }else {
        _this.queryRole();
        $(e.target).parents('.account-box').find('.utm-account-wapper2').slideDown(300);
      }
      _this.roleName = '';
      _this.accountGroupName = '';
      _this.accountName = '';
    },
    queryRole:function(){
      _this.reciverData.name = _this.roleName;
      let data = JSON.parse(JSON.stringify(_this.reciverData));
      this.$ajax.post('Roles/Pagination', data,{headers: {'noLoading': true} ,baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if (res.data.success) {
          _this.allRoleList = res.data.data.items;
        } else {
          _this.messageNotice('error', res.data.message);
        }
      });
    },
    //获取所有管理账号组
    queryAccountGroup: function () {
      _this.reciverData.name = _this.accountGroupName;
      let data = JSON.parse(JSON.stringify(_this.reciverData));
      this.$ajax.post('AccountGroups/Paginate', data,{headers: {'noLoading': true} ,baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if (res.data.success) {
          _this.allAccountGroupList = res.data.data.items;
        } else {
          _this.messageNotice('error', res.data.message);
        }
      });
    },
    addReceiverRole:function(data,index){
      let array = _this.receivers[index].receiverRoleIds.filter(item =>{
        return item.id == data.id;
      });
      if(array.length == 0){
        _this.receivers[index].receiverRoleIds.push(data.id);
      }
      _this.validateReceiver(index);
    },
    deleteReceiverRole:function(id,preIndex){
      let index = _this.receivers[preIndex].receiverRoleIds.indexOf(id);
      if(index === -1){
        _this.receivers[preIndex].receiverRoleIds.splice(index,1);
      }
      _this.validateReceiver(preIndex);
    },
    //获取所有管理员
    getAllAccount:function(){
      _this.reciverData.name = _this.accountName;
      let data = JSON.parse(JSON.stringify(_this.reciverData));
      this.$ajax.post('Accounts/Pagination',data,{headers: {'noLoading': true},baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if(res.data.success){
          _this.allAccountList = res.data.data.items;
        }else{
          _this.messageNotice('error', res.data.message);
        }
        _this.scrollFlag = false;
      });
    },
    searchItem:function(type){
      clearTimeout(_this.timer);
      _this.timer = setTimeout(function(){
        if(type === 0 ){
          _this.getAllAccount();
        }else if (type === 1) {
          _this.queryAccountGroup();
        }else {
          _this.queryRole();
        }
      },1000);
    },
    // 新增账号组接收者
    addReceiverGroup:function (data,index) {
      let array = _this.receivers[index].receiverGroupIds.filter(item =>{
        return item.id == data.id;
      });
      if(array.length == 0){
        _this.receivers[index].receiverGroupIds.push(data.id);
      }
      _this.validateReceiver(index);
    },
    // 删除接收账号组
    deleteReceiverGroup:function (index,preIndex) {
      _this.receivers[preIndex].receiverGroupIds.splice(index,1);
      _this.validateReceiver(preIndex);
    },
    /*新增账号*/
    addReceiverAdmin:function(item,preIndex){
      let index = _this.receivers[preIndex].receiverIds.indexOf(item.id);
      if(index === -1){
        _this.receivers[preIndex].receiverIds.push(item.id);
      }
      _this.validateReceiver(preIndex);
    },
    /*删除账号*/
    deleteReceiverAdmin:function(item,preIndex){
      let index = _this.receivers[preIndex].receiverIds.indexOf(item.id);
      if(index > -1){
        _this.receivers[preIndex].receiverIds.splice(index,1);
      }
      _this.validateReceiver(preIndex);
    },
    // Receiver表单验证
    validateReceiver(index){
      let rec = _this.receivers[index].receiverGroupIds.length + _this.receivers[index].receiverIds.length + _this.receivers[index].receiverRoleIds.length;
      if(rec > 0){
        _this.receivers[index].receiverFlag = false;
      }else{
        _this.receivers[index].receiverFlag = true;
      }
    },
    // FileType表单验证
    validateFileType(index){
      if(_this.receivers[index].fileTypes && _this.receivers[index].fileTypes.length > 0){
        _this.receivers[index].formatFlag = false;
      }else{
        _this.receivers[index].formatFlag = true;
      }
    },
    deleteFormatReciver(index){
      if(_this.receivers.length > 1){
        _this.receivers.splice(index,1);
      }
    },
    // 打开编辑模板
    editEmailTemplate: function () {
      _this.cursorPosition = 0;
      _this.emailTitleFlag = false;
      _this.emailFlag = false;
      _this.emailTitle = _this.emailSubject;
      _this.emailText = _this.emailContent;
      _this.editEmailModal = true;
    },
    // 获取光标位置
    getCurPoint:function () {
      _this.cursorPosition  = this.$refs.myQuillEditor.quill.selection.savedRange.index;
    },
    // 验证邮箱模板信息
    validateEmail:function () {
      if(_this.emailText){
        _this.emailFlag = false;
      }else{
        _this.emailFlag = true;
      }
    },
    validateEmailSubject(){
      if(_this.emailTitle){
        _this.emailTitleFlag = false;
      }else{
        _this.emailTitleFlag = true;
      }
    },
    addFormatReciver(){
      let obj = {
        fileType: null,
        fileTypes: [],
        receiverGroupIds: [],
        receiverIds: [],
        receiverRoleIds :[],
        formatFlag: false,
        receiverFlag: false,
        sendFormat:0,
      }
      _this.receivers.push(obj);
    },
    // 保存模板信息
    saveTemplateInfo: function () {
      _this.validateEmail();
      _this.validateEmailSubject();
      if(!_this.emailFlag && !_this.emailTitleFlag) {
        _this.editEmailModal = false;
        _this.$set(_this,'emailSubject',_this.emailTitle);
        _this.$set(_this,'emailContent',_this.emailText);
        _this.$forceUpdate();
      }
    },
    confirm:function () {
      if(_this.emailSubject){
        _this.emailTitleFlag = false;
      }else {
        _this.emailTitleFlag = true;
      }
      if (_this.emailContent){
        _this.emailFlag = false;
      }else {
        _this.emailFlag = true;
      }
      _this.validateReceiver(0);
      let isAutoSendEmailFlag;
      if(!_this.receivers[0].receiverFlag && !_this.emailFlag && !_this.emailTitleFlag){
        isAutoSendEmailFlag = false;
      }else {
        isAutoSendEmailFlag = true
      }
      if(!isAutoSendEmailFlag){
        let params = {
          id:_this.id,
          emailContent:_this.emailContent,
          emailSubject: _this.emailSubject,
          recipients:[],
        };
        if(_this.receivers && _this.receivers.length) {
          _this.receivers.forEach(item => {
            if (item.receiverRoleIds && item.receiverRoleIds.length) {
              item.receiverRoleIds.forEach(role => {
                params.recipients.push({type:2,value:role});
              })
            }
            if (item.receiverGroupIds && item.receiverGroupIds.length) {
              item.receiverGroupIds.forEach(group => {
                params.recipients.push({type:1,value:group});
              })
            }
            if (item.receiverIds && item.receiverIds.length) {
              item.receiverIds.forEach(id => {
                params.recipients.push({type:0,value:id});
              })
            }
          })
        }
        _this.$ajax.post('GenerateReport/SendEmail',params).then(res=>{
          if (res.data.success) {
            _this.messageNotice('success');
            _this.sendEmailModal = false;
          } else {
            _this.messageNotice('error', res.data.message);
          }
        })
      }else {
        return false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/forwardEmail.js